import apiClient from '../../../Services/ApiClient';
import useApiClient from './useApiClient';
import { CustomSettingKey } from '../Enums/CustomSettingKey.enum';
import { formatObjectForQuery } from '../../../Services/Api/FormatObjectForQuery';

export default function useCustomSettings(
	workplaceId: string,
	userId?: string,
) {
	const { displayError } = useApiClient();

	const getCustomSettings = async (key: CustomSettingKey) => {
		try {
			const params = formatObjectForQuery({
				key,
				workplaceId,
				userId,
			});
			const response = await apiClient.get(`/custom-settings?${params}`);
			if (response.data) {
				return response.data;
			} else {
				return undefined;
			}
		} catch (e) {
			displayError(e);
		}
	};

	const saveCustomSettings = async (key: CustomSettingKey, data: object) => {
		try {
			return await apiClient.post('/custom-settings', {
				workplaceId,
				userId,
				key,
				value: data,
			});
		} catch (e) {
			displayError(e);
		}
	};

	return {
		getCustomSettings,
		saveCustomSettings,
	};
}
